import { render, staticRenderFns } from "./friendReceive.vue?vue&type=template&id=3911be02&scoped=true&"
import script from "./friendReceive.vue?vue&type=script&lang=js&"
export * from "./friendReceive.vue?vue&type=script&lang=js&"
import style0 from "./friendReceive.vue?vue&type=style&index=0&id=3911be02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911be02",
  null
  
)

export default component.exports